<template>
<div>
  <v-data-table flat v-model="selected" :headers="headers" :items="resources"
    class="elevation-2" :loading="isLoading" :total-items="totalResources"
    :rows-per-page-items="[50, 100]" :pagination.sync="pagination" select-all
    item-key="id" disable-initial-sort
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th>
          <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate"
            primary hide-details @click.stop="toggleAll" >
          </v-checkbox>
        </th>
        <th v-for="header in props.headers" :key="header.text" hide-details
          class="text-capitalize" >
          {{ header.text }}
        </th>
      </tr>
    </template>

    <template slot="items" slot-scope="props">
      <tr :active="props.selected" @click="props.selected = !props.selected">
      <td>
        <v-checkbox :input-value="props.selected" primary ></v-checkbox>
      </td>
      <td class="text-xs-center">{{ dateFormatted(props.item.due_on) }}</td>
      <td class="text-xs-center">{{ daysToDeposit(props.item.due_on) }}</td>
      <td class="text-xs-center">{{ props.item.payment_id }}</td>
      <td class="text-xs-center">{{ $n(props.item.amount, 'currency') }}</td>
      <td class="text-xs-center">{{ $n(props.item.amount_with_anticipation_fee, 'currency') }}</td>
      <td class="text-xs-center">
        <v-chip :color="setChipColor(props.item.status)"
          class="text-capitalize" small text-color="white">
            {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td class="text-xs-center">
        {{ props.item.installment }}
      </td>
      <td class="text-xs-center">{{ $d(new Date(props.item.updated_at), 'dateAndTime') }}</td>
      </tr>
    </template>
  </v-data-table>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  mounted() {
    this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
  },
  computed: {
    ...mapGetters({
      resources: 'user/anticipationsAvailable',
      totalResources: 'user/anticipationsAvailableCount',
      currentTax: 'user/currentTax',
      filters: 'user/anticipationsFilter',
      selectedAnticipations: 'user/selectedAnticipations',
      selectedAnticipationsLimit: 'user/selectedAnticipationsLimit',
      currentPage: 'user/anticipationsAvailablePage',
      isLoading: 'user/loading',
    }),
    pages() {
      return 0;
    },
  },
  watch: {
    selected: function selected(selected) {
      let value = 0;
      selected.forEach((deposit) => {
        value += parseFloat(deposit.amount_with_anticipation_fee);
      });
      this.updateSelectedAnticipationsAmount(value);
      this.updateSelectedAnticipations(selected);
    },
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.page, oldPagination.page)) {
        this.updateSelectedAnticipationsPage(newPagination.page);
        this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
      }
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.updateSelectedAnticipationsLimit(newPagination.rowsPerPage);
        this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setSelectAnticipations: 'user/setSelectAnticipations',
      updateSelectedAnticipationsAmount: 'user/updateSelectedAnticipationsAmount',
      updateSelectedAnticipationsLimit: 'user/updateAnticipationsAvailableLimit',
      updateSelectedAnticipationsPage: 'user/updateAnticipationsAvailablePage',
      updateSelectedAnticipations: 'user/updateSelectedAnticipations',
    }),
    dateFormatted(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    toggleAll() {
      if (this.selected.length !== 0) {
        this.selected = [];
      } else {
        this.selected = this.resources.slice();
        this.setSelectAnticipations(this.selected);
      }
    },
    daysToDeposit(date) {
      const now = moment();
      const depositDate = moment(date);
      return depositDate.diff(now, 'days');
    },
  },
  data() {
    return {
      items: [],
      selected: [],
      count: 0,
      pagination: {},
      headers: [
        { text: 'Data para depósito', value: 'efetuado em' },
        { text: 'Dias para depósito', value: 'value' },
        { text: 'Referente ao Pagamento', value: 'rates' },
        { text: 'Valor', value: 'toReceive' },
        { text: 'Valor Antecipável', value: 'depositIn' },
        { text: 'Status', value: 'payment' },
        { text: 'Parcela', value: 'installment' },
        { text: 'Ultima Atualização', value: 'cardBrand' },
      ],
    };
  },
};
</script>
